/**
 * cvSelectionState.js
 * Shared util: seed the canvas selectionState from a CV data object.
 * Used by CabinCVWizard (student) and InstructorCVReviews (preview).
 */

/**
 * Derives initial canvas selectionState from cvData.
 * Determines which sections and individual experience/language entries
 * are included in the CV output.
 *
 * @param {object|null} cv - CV data object (e.g. detail.merged or cvData)
 * @returns {{ includedSections, isDeneyimleriInclude, dillerInclude }}
 */
export function seedSelectionState(cv) {
  const hasIsDen = Array.isArray(cv?.is_deneyimleri) && cv.is_deneyimleri.length > 0;
  const hasDil = !!(cv?.dil?.ingilizce_seviye || (Array.isArray(cv?.dil?.diller) && cv.dil.diller.length > 0));
  const hasEgitim = !!(cv?.egitim?.okul || cv?.egitim?.mezuniyet_durumu);
  const hasHakkimda = !!cv?.hakkimda;

  const isDeneyimleriInclude = {};
  (cv?.is_deneyimleri || []).forEach((e, i) => {
    isDeneyimleriInclude[i] = e.include_in_cv !== false;
  });

  const dillerInclude = {};
  (cv?.dil?.diller || []).forEach((d, i) => {
    dillerInclude[i] = d.include_in_cv !== false;
  });

  return {
    includedSections: {
      is_deneyimleri: hasIsDen,
      dil: hasDil,
      egitim: hasEgitim,
      hakkimda: hasHakkimda,
      referanslar: false,
    },
    isDeneyimleriInclude,
    dillerInclude,
  };
}
